import { $, gsap } from "../shared/globals.js";

export function createParallaxFeature({ context, CONFIG }) {
    const { $parallaxImgs } = context;

    let mouseX = 0;
    let mouseY = 0;
    let parallaxX = 0;
    let parallaxY = 0;
    let parallaxEnabled = false;
    let rafId = null;

    const baseRotations = {};

    function handleMouseMove(event) {
        mouseX = (event.clientX / window.innerWidth) * 2 - 1;
        mouseY = (event.clientY / window.innerHeight) * 2 - 1;
    }

    function animateParallax() {
        if (!parallaxEnabled) return;

        parallaxX += (mouseX - parallaxX) * CONFIG.parallaxSmoothing;
        parallaxY += (mouseY - parallaxY) * CONFIG.parallaxSmoothing;

        $parallaxImgs.each(function(index) {
            const $img = $(this);
            const intensity = parseFloat($img.data("mouse")) || 1;
            const rotateY = parallaxX * CONFIG.parallaxIntensity * intensity;
            const rotateX = -parallaxY * CONFIG.parallaxIntensity * intensity * 0.5;
            const rotateZ = parallaxX * 4 * intensity;
            const finalRotation = (baseRotations[index] || 0) + rotateZ;

            gsap.set(this, {
                rotationY: rotateY,
                rotationX: rotateX,
                rotation: finalRotation,
                transformPerspective: 1000,
            });
        });

        rafId = requestAnimationFrame(animateParallax);
    }

    function enableParallax3D() {
        if (parallaxEnabled) return;

        parallaxEnabled = true;

        $parallaxImgs.each(function(index) {
            baseRotations[index] = gsap.getProperty(this, "rotation") || 0;
        });

        $(document).on("mousemove.parallax", handleMouseMove);
        animateParallax();
    }

    function destroy() {
        if (rafId) {
            cancelAnimationFrame(rafId);
            rafId = null;
        }

        $(document).off("mousemove.parallax", handleMouseMove);
        parallaxEnabled = false;
        mouseX = 0;
        mouseY = 0;
        parallaxX = 0;
        parallaxY = 0;
    }

    return {
        enableParallax3D,
        destroy,
    };
}
